import { Building } from './building.model';
import { BuildingInterface } from './building.interface';

export class BuildingFactory {

    static empty(): Building {
        return new Building('', '', [], '');
    }

    static fromObject(raw: BuildingInterface | any): Building {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Building(
            raw.id,
            raw.name,
            raw.groups || [],
            raw.description,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/buildings/shared/building.factory.ts